import React from 'react';
import styles from './DateFilter.module.css';
import { FaCalendarAlt, FaTimes } from 'react-icons/fa'; // Importa ícones

/**
 * Componente que renderiza o input de filtro por um dia específico.
 * Ele recebe o estado e as funções para alterá-lo como props.
 */
const DateFilter = ({ selectedDate, onDateChange, onClearFilter }) => {
  return (
    <div className={styles.container} title={selectedDate ? `Filtrando por: ${selectedDate}` : 'Filtrar por data'}>
      <label htmlFor="date-filter" className={styles.iconLabel}>
        <FaCalendarAlt />
        <input
          type="date"
          id="date-filter"
          value={selectedDate}
          onChange={(e) => onDateChange(e.target.value)}
          className={styles.dateInput}
        />
      </label>
      {selectedDate && (
        <button onClick={onClearFilter} className={`${styles.iconLabel} ${styles.clearButton}`} title="Limpar Filtro">
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default DateFilter;